export function ErrorMessageSubscribe(error) {
  let errorMessage = '';
  if (error.error.response.data.error.line === 189) {
    errorMessage = 'Dəyəri qeyd olunmuş, xidmətin adını qeyd edin.';
  }

  return errorMessage;
}
